<template>
  <div>
    <el-dialog
        v-if="blockedDialogVisible"
        :close-on-click-modal="false"
        :visible.sync="blockedDialogVisible"
        center
        width="60%"
        @close="closePanel">
      <div class="header-btn">
        <el-button icon="el-icon-plus" size="small" type="warning" @click="openCreate"></el-button>
      </div>
      <el-table
          :data="data"
          class="data-table"
          fit
          stripe>
        <el-table-column
            v-for="item in [
                            {prop:'blockedDateStart',label:'Blocked Range Start Date',fmt:selfDateFormat},
                            {prop:'blockedDateEnd',label:'Blocked Range End Date',fmt:selfDateFormat},
                            {prop:'created',label:'Created'},
                        ]"
            :key="item.label"
            :formatter="item.fmt"
            :label="item.label"
            :prop="item.prop"
            align="center"
            header-align="center">
        </el-table-column>

        <el-table-column
            align="center"
            header-align="center"
            label="Action">
          <template slot-scope="s">
            <el-button icon="el-icon-delete" size="small" type="danger"
                       @click="deleteData(s.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination :current-page.sync="page.page"
                       :page-count="page.totalPage"
                       :page-size="page.size"
                       :total="data.total"
                       layout="prev, pager, next"
                       @current-change="loadData">
        </el-pagination>
      </div>

      <el-dialog
          v-if="dialogVisible"
          :visible.sync="dialogVisible"
          append-to-body
          center
          width="40%">
        <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="100px">
          <el-form-item label="Blocked Date" prop="blockedDate">
            <el-date-picker
                v-model="form.blockedDate"
                end-placeholder="End Date"
                format="dd MMM yyyy"
                start-placeholder="Start Date"
                type="daterange"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="medium">Cancel</el-button>
                    <el-button type="primary" @click="saveData" size="medium">Save</el-button>
                </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {facilityBlocked, facilityBlockedCreate, facilityBlockedDelete} from '@/api/Facitliy'

export default {
  name: "FacilityBlocked",
  props: {
    blockedDialogVisible: {required: true},
    fid: {required: true}
  },
  data: function () {
    return {
      dialogVisible: false,
      form: {},
      queryForm: {},
      loading: false,
      data: [],
      page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
      rules: {}
    }
  },
  methods: {
    loadData() {
      this.$pageUtils(this, facilityBlocked)
    },
    openCreate() {
      this.form = {
        blockedDate: []
      }
      this.dialogVisible = true
    },
    closePanel() {
      this.$emit('update:blockedDialogVisible', false)
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const form = this.$copy(this.form)
          form.fid = this.fid
          form.blockedDateStart = form.blockedDate[0]
          form.blockedDateEnd = form.blockedDate[1]
          delete form.blockedDate
          facilityBlockedCreate(form)
              .then(() => {
                this.loadData()
                this.dialogVisible = false
              })
        }
      })
    },
    deleteData(id) {
      this.$deleteRequest(this, facilityBlockedDelete, id)
    }
  },
  mounted() {
    this.queryForm.fid = this.fid
    this.loadData()
  }
}
</script>

<style scoped>
@media screen and (min-width: 1300px) {
  .el-form-item {
    margin-left: 120px;
  }
}
</style>
